export const SUPABASE_URL='https://okrufrxhgkwrflhtlfmc.supabase.co';
export const SUPABASE_PUBLISHABLE_KEY='sb_publishable_f-JAkY4_69GG-VeyDD4VOw_1rheutmA';

// A secret key do Turnstile fica somente no Supabase Auth.
export const TURNSTILE_SITE_KEY='0x4AAAAAAD6tYeVSxHKV_rNa';

// Espelho local das Regras/Privacidade 1.0 (fonte: migration rules_privacy_v1 e
// docs/LEGAL-REGRAS-PRIVACIDADE.md). Usado só se a leitura do DB falhar no cadastro.
export const FALLBACK_RULES={
  version:'1.0',
  status:'published',
  content:{
    'pt-BR':{
      title:'Regras e Privacidade',
      summary:[
        'Respeite os outros jogadores: proibido racismo, discurso de ódio, palavrões e nomes ofensivos. O chat e os nomes passam por filtro automático.',
        'Jogo limpo: nada de bots, exploração de falhas, duplicação de recursos ou venda de conta/itens por dinheiro real. Abuso pode ser revertido e a conta banida.',
        'Economia em desenvolvimento: taxas, preços e progressão podem ser ajustados; saldos de jogo não têm valor em dinheiro.',
        'Esmeraldas são moeda virtual de uso interno, sem saque ou conversão em dinheiro. Estornos podem removê-las da conta.',
        'Coletamos e-mail, nome de treinador, progresso e IP (segurança). Pagamento pela Stripe; não guardamos dados de cartão. Não vendemos seus dados.',
        'Você pode pedir acesso, correção ou exclusão dos seus dados pelo contato do jogo. Detalhes na Política de Privacidade.',
      ],
    },
    en:{
      title:'Rules and Privacy',
      summary:[
        'Respect other players: no racism, hate speech, profanity, or offensive names. Chat and names are automatically filtered.',
        'Fair play: no bots, exploiting bugs, duplicating resources, or selling accounts/items for real money. Abuse can be reversed and the account banned.',
        'Live economy: rates, prices, and progression may be adjusted; in-game balances have no cash value.',
        'Emeralds are in-game virtual currency only, with no withdrawal or cash conversion. Chargebacks may remove them from the account.',
        'We collect email, trainer name, progress, and IP (security). Payments via Stripe; we do not store card data. We do not sell your data.',
        'You may request access, correction, or deletion of your data via the in-game contact. Details in the Privacy Policy.',
      ],
    },
    es:{
      title:'Reglas y Privacidad',
      summary:[
        'Respeta a los demás jugadores: prohibido el racismo, el discurso de odio, las groserías y los nombres ofensivos. El chat y los nombres se filtran automáticamente.',
        'Juego limpio: nada de bots, explotar fallos, duplicar recursos ni vender cuentas/objetos por dinero real. El abuso puede revertirse y la cuenta ser baneada.',
        'Economía en desarrollo: tasas, precios y progresión pueden ajustarse; los saldos del juego no tienen valor en dinero.',
        'Las Esmeraldas son moneda virtual de uso interno, sin retiro ni conversión a dinero. Los contracargos pueden eliminarlas de la cuenta.',
        'Recopilamos correo, nombre de entrenador, progreso e IP (seguridad). Pago por Stripe; no guardamos datos de tarjeta. No vendemos tus datos.',
        'Puedes solicitar acceso, corrección o eliminación de tus datos por el contacto del juego. Detalles en la Política de Privacidad.',
      ],
    },
  },
};
